import { useContext, useEffect, useState } from "react";
import LoginRequired from "../LoginRequired.jsx";
import UserContext from "../UserContext.jsx";
import { Crumbs } from "../Crumbs.jsx";
import { Box, Paper, Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, ToggleButtonGroup, ToggleButton } from "@mui/material";
import Link from "@mui/material/Link";
import AddEventButton from "../Button/AddEventButton.jsx";
import { isValidURL } from "../../shared/validate.js";
import {InTownURI} from "../Button/InTownButton.jsx"
import {OutOfTownURI} from "../Button/OutOfTownButton.jsx"
import stateOptions from "../../shared/stateOptions";

const EditVenuePage = (props) => {
    const {documentId} = props.match.params;

    return <Box m={2}>
    

            <Crumbs crumbs={[
                {title: "Where to Dance", href: "/where-to-dance"},
                {title: "Edit Venue"}
            ]}/>

        <LoginRequired>
            <EditVenueForm documentId={documentId}/>

        </LoginRequired>
    </Box>
};


const EditVenueForm = (props) => {

    const documentId = props.documentId || "new";
    const emptyVenue = {
        venueKey:  "",
        location: "",
        name: "",
        address: "",
        city: "",
        state: "-",
        zip: "",
        cover: "",
        age: "all-ages",
        daysToVisit: "",
        insta: "",
        website: "",
        whatToExpect: "",
        market: "local",
        documentId: documentId
    }
    const [formData, setFormData] = useState(emptyVenue);
    const [loading, setLoading] = useState(true)
    const [saving, setSaving] = useState(false)
    const [state, setState] = useState("unchanged")

    const user = useContext(UserContext)


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setState("modified")
    };

    const handleAgeChange = (e) => {
        const { value } = e.target;
        setFormData((prev) => ({ ...prev, age: value }));
        setState("modified")
    }

    const loadVenue = async (documentId) => {
        fetch(`${process.env.REACT_APP_BACKEND_HOST}/venues/${documentId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then(res => res.json())
        .then(obj => obj.data)
        .then(venue => {
             delete venue.id;
             delete venue.createdAt;
             delete venue.updatedAt;
             delete venue.publishedAt;
            //  delete venue.documentId
            if (venue.state === null) {
                venue.state = "-";
            }
            setFormData(venue);
            setLoading(false);
        })
        .catch(err => {
            console.error(err);
            setLoading(false);
        });
    };

    useEffect(() => {
        if (!formData.documentId) {
            setLoading(false)
            return;
        }
        loadVenue(formData.documentId);

    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();

        setSaving(true);
        setState("saving");

        try {
            const {documentId, ...submitData} = formData;
            const URI = documentId === "new" ? "/venues" : `/venues/${documentId}`;
            const method = documentId === "new" ? "POST" : "PUT";

            const res = await fetch(`${process.env.REACT_APP_BACKEND_HOST}${URI}`, {
                method: method,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
                },
                body: JSON.stringify({data: submitData})
            });
            const result = await res.json();
            if (!res.ok || result === false) {
                setState("failed");
            } else {
                setState("saved");
                loadVenue(result.documentId);
            }
        } catch (err) {
            setState("failed");
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <Paper>Loading</Paper>
    }

    if (state === "saved") {
        return <Box>
            <Box>
                <Link href={"/venue/" + documentId}>{formData.name}</Link> page has been updated.
            </Box>
            <Box mt={2}>
                <AddEventButton venueKey={formData.venueKey} />
                <Button size={"small"}  href={"/venue/edit/" + documentId}>Edit Again</Button>
                <br />
                <Button href={"/venue/edit/new"} size={"small"} >New Venue</Button>
            </Box>
            <Box mt={2}>
                Go back to the <Link href={InTownURI}>In Town Page</Link>
            </Box>
            <Box mt={2}>
                Go back to the <Link href={OutOfTownURI}>Out of Town Page</Link>
            </Box>
        </Box>
    }

    return (
       <Box>
         
            <Paper elevation={3} sx={{ p: 4, margin: 'auto' }}>

            <Box component="form" onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <TextField
                          required
                          disabled={saving}
                          fullWidth
                          label={"Venue Name"}
                          name={"name"}
                          value={formData.name || ""}
                          onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                          required
                          disabled={saving}
                          fullWidth
                          label={"Address"}
                          name={"address"}
                          value={formData.address || ""}
                          onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                          required
                          disabled={saving}
                          fullWidth
                          label={"City"}
                          name={"city"}
                          value={formData.city || ""}
                          onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <InputLabel>State *</InputLabel>
                            <Select
                                value={formData.state}
                                label={"state"}
                                required
                                onChange={(e) => handleChange({target: {name: 'state', value: e.target.value}})}>
                                <MenuItem key={"-"} value={"-"}>Select</MenuItem>
                                {stateOptions.map(state => <MenuItem key={state.key} value={state.key}>{state.name}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            required
                            disabled={saving}
                            fullWidth
                            label={"Zip Code"}
                            helperText={"5 digit zip code"}
                            name={"zip"}
                            value={formData.zip || ""}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            required
                            disabled={saving}
                            fullWidth
                            label={"Cover"}
                            helperText={"Free OR expected price range"}
                            name={"cover"}
                            value={formData.cover || ""}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <ToggleButtonGroup
                            fullWidth
                            value={formData.age || "21+"}
                            disabled={saving}
                            exclusive
                            onChange={handleAgeChange}>
                            <ToggleButton value={"21+"}>21+</ToggleButton>
                            <ToggleButton value={"all-ages"}>All Ages</ToggleButton>
                            <ToggleButton value={"minor-with-guardian"}>Minors w/ Guardian</ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            disabled={saving}
                            fullWidth
                            label={"Days to Visit"}
                            helperText={"(Monday, Wednesday, etc)"}
                            name={"daysToVisit"}
                            value={formData.daysToVisit || ""}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            disabled={saving}
                            fullWidth
                            label={"Instagram name"}
                            helperText={"(Don't include @)"}
                            name={"insta"}
                            value={formData.insta || ""}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            disabled={saving}
                            fullWidth
                            label={"Website"}
                            name={"website"}
                            helperText={"the full URL including https://"}
                            value={formData.website || ""}
                            error={formData.website && !isValidURL(formData.website)}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            disabled={saving}
                            fullWidth
                            multiline
                            rows={4}
                            label={"What To Expect"}
                            helperText={"(Type of floor, dancing style, live music, etc)"}
                            name={"whatToExpect"}
                            value={formData.whatToExpect || ""}
                            onChange={handleChange}
                        />
                    </Grid>


             
            </Grid>
            <Box mt={3} textAlign="right">
                <div>
                    {state === 'modified' && "You have unsaved changes."}
                    {state === 'saved' && "Venue is saved."}
                    {state === 'failed' && "Save failed."}
                    {state === 'saving' && "Saving..."}
                </div>
              <Button type="submit" variant="contained" color="primary" disabled={state === 'saving' || state === 'saved'}>
                Save
              </Button>
            </Box>
          </Box>
        </Paper>
    </Box>
);
};

export default EditVenuePage